<template>
  <div class="viewsrhwxEvaluate_Result" v-if="showContent">
    <div class="iconDiv">
      <van-icon class="vanIconC" name="passed" />
      <span> 提交成功 </span>
    </div>
    <div class="desc">
      感谢您的宝贵意见，如您已办理完所有手续，即可开车离厂，祝您一路平安！
    </div>
    <div class="divide">
      <div class="divide-line"></div>
      您还可以：
    </div>
    <noticeList :bg="bg" btnText="进入" @viewDetail="viewDetail"></noticeList>
    <van-button block class="btnStyle2" @click.stop="goBack">关闭</van-button>
  </div>
</template>

<script>
// import { Toast } from "vant";
import noticeList from "../../../components/noticeList";
export default {
  components: {
    noticeList
  },
  data() {
    return {
      tag: false, // 是否已报到
      btnStyle: "btn", // 立即报到按钮样式
      bg: [
        {
          img: require("../assets/img/route_bg.png"),
          title: "查看厂区平面图",
          color1: "#62E9C5",
          color2: "#3BC69E",
          route: "/rhwxRouteGuide",
          query: {
            map_type: "ht"
          }
        },
        {
          img: require("../assets/img/car_bg.png"),
          title: "阅读安全告知书",
          color1: "#FEC375",
          color2: "#F28E1E",
          route: "/rhwxNotice",
          query: {
            type: "success",
            map_type: "ht"
          }
        }
      ],
      signTag: 0, // 0为第一次报到，1为今日非首次报到
      signText: "",
      isSign: false, // 是否已报到
      isFirstSign: false, //是否为首次报到
      hasOnGoing: false, //是否有前置进行中的业务
      isInvalid: false, //是否报到失效
      rowDataObj: {},
      comName: "",
      showContent: false
    };
  },
  mounted() {
    this.getDetail();
    this.getName();
  },
  computed: {
    sub_com_id() {
      return this.$route.query.sub_com_id;
    }
  },
  methods: {
    // 获取厂区名称
    getName() {
      this.$common
        .http({
          url: "/api/queue/summary/com_info",
          data: {
            com_id: this.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          this.comName = res.data.data.com_info.name;
          this.showContent = true;
        });
    },

    // 查看详情
    viewDetail(route, query) {
      console.log(route, query);
      this.btnStyle = "btn";
      // 今日未报到
      // if (!this.isSign || this.isInvalid) {
      // 1、立即报到 2、再次报到-已有业务  3、再次报到-正常报到 4、重新报到
      // 报到逻辑：
      // 1.1、前提：===2（已有业务）
      // 1.2、当前报到的厂区与访问的报到链接厂区不一致，提示其他厂区有正在进行中的业务
      // 1.3、否则，判断是否有排队信息，是否有安全告知书信息
      if (this.rowDataObj.report_state === 2) {
        if (this.rowDataObj.report.com_id === this.$route.query.sub_com_id) {
          if (route === "/rhwxQueueBoard") {
            // 当前无排队信息时，禁止司机查看
            if (
              Number(this.rowDataObj.report.is_input_queue) === 0 ||
              this.rowDataObj.business.length === 0
            ) {
              this.$common.mbToastFail("当前账号无排队信息");
              return false;
            } else if (Number(this.rowDataObj.report.booking_state) === 8) {
              this.$common.mbToastFail("车辆已离厂");
              return false;
            } else {
              this.$router.push({
                path: route,
                query: {
                  map_type: this.$route.query.map_type,
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id
                }
              });
            }
          } else if (route === "/rhwxNotice") {
            if (this.rowDataObj.safetyNotice.length === 0) {
              this.$common.mbToastFail("当前无排队安全告知书信息");
              return false;
            } else {
              this.$router.push({
                path: route,
                query: {
                  type: "success",
                  map_type: this.$route.query.map_type,
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id
                }
              });
            }
          } else {
            this.$router.push({
              path: route,
              query: {
                map_type: this.$route.query.map_type,
                com_id: this.$route.query.com_id,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          }
        } else {
          this.$common.mbToastFail("其它厂区有正在进行的业务");
          return false;
        }
      } else {
        // 2.1、前提： ===1、2、3（立即报到、正常报到、重新报到）
        // 2.2、可以正常报到
        // Toast({
        //   message: "请先报到",
        //   className: "toastEDE"
        // });
        this.$common.mbToastFail("请先报到");
        setTimeout(() => {
          this.btnStyle = "btn-animation";
        }, 2000);
      }
      // } else {
      //   this.$common.mbToastFail("其它厂区有正在进行的业务");
      //   return false;
      // }
    },

    // 报到
    signIn() {
      // if (this.isSign && this.hasOnGoing) {
      //   Toast({
      //     message: "请先完成前一次预约业务后再报到",
      //     className: "toastEDE"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/rhwxCheckin/0"
      //   });
      // }
      if (this.rowDataObj.report_state === 2) {
        if (this.rowDataObj.report.com_id === this.$route.query.sub_com_id) {
          // Toast({
          //   message: "请先完成前一次预约业务后再报到",
          //   className: "toastEDE"
          // });
          this.$common.mbToastFail("请先完成前一次预约业务后再报到");
        } else {
          this.$common.mbToastFail("其它厂区有正在进行的业务");
        }
      } else {
        this.$router.push({
          path: "/rhwxCheckin/0",
          query: {
            map_type: this.$route.query.map_type,
            com_id: this.$route.query.com_id,
            sub_com_id: this.$route.query.sub_com_id
          }
        });
      }
    },

    // 获取报到详情
    getDetail() {
      this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          // 1 立即报到  2 再次报到-已有业务  3 再次报到-正常报到  4-重新报到
          this.rowDataObj = res.data.data;
          if (this.rowDataObj.report_state === 1) {
            this.signText = "立即报到";
          } else if (
            this.rowDataObj.report_state === 2 ||
            this.rowDataObj.report_state === 3
          ) {
            this.signText = "再次报到";
          } else if (this.rowDataObj.report_state === 4) {
            this.signText = "重新报到";
          } else {
            this.signText = "立即报到";
          }
        });
    },
    goBack() {
      this.$router.push({
        path: "rhwxIntoCodeAllPath",
        query: {
          app_id: this.$route.query.app_id,
          com_id: this.$route.query.com_id,
          sub_com_id: this.$route.query.sub_com_id,
          map_type: this.$route.query.map_type
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.viewsrhwxEvaluate_Result {
  padding: 16px;
  font-size: 16px;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .iconDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    line-height: 20px;
    padding: 40px 0 20px 0;
    .vanIconC {
      margin-right: 6px;
    }
  }
  .logo {
    text-align: center;
    padding: 18px 27px 26px;
  }
  .desc {
    font-size: 16px;
    color: #008b5e;
    text-align: center;
    line-height: 25px;
    margin-bottom: 45px;
  }
  .btn {
    padding: 22px 0px 30px;
  }
  .btn-animation {
    padding: 22px 0px 30px;
    animation: fade 1000ms 2;
    -webkit-animation: fade 1000ms 2;
  }
  .divide {
    opacity: 0.8;
    &-line {
      height: 16px;
      width: 4px;
      background: #009967;
      display: inline-block;
      vertical-align: text-top;
    }
  }
  .btnStyle2 {
    position: absolute;
    bottom: 16px;
    margin: 0 !important;
    width: calc(100% - 32px);
    box-sizing: border-box !important;
  }
}

@keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-ms-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
</style>
